import { useState } from "react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import Loader from "common/components/Loader";
import SearchInput from "common/components/SearchInput";
import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useAgencyClients from "../../datahooks/useAgencyClients";
import DesktopTable from "./DesktopLayout/DesktopTable";
import MobileList from "./MobileLayout/MobileList";
import NewClientButton from "./NewClientButton";

import ResultNotFoundImage from "assets/images/empty-placeholders/result-not-found.png";
import EmptyPlaceholderImage from "assets/images/empty-placeholders/webhooks.png";

export default function Clients() {
  const isDesktop = useTwBreakpoint("lg");

  const [searchTerm, setSearchTerm] = useState("");

  const {
    agencyClients,
    isLoadingAgencyClients,
    isAgencyClientsError,
    refetchAgencyClients,
  } = useAgencyClients();

  if (isAgencyClientsError) {
    return (
      <ErrorPlaceholder
        errorMessage="Could not display clients"
        onRetry={refetchAgencyClients}
      />
    );
  }
  if (isLoadingAgencyClients) {
    return <Loader />;
  }
  if (!agencyClients?.length) {
    return (
      <EmptyPlaceholder
        imageSrc={EmptyPlaceholderImage}
        title="No clients found"
        subtitle="Add a client to get started"
        actionComponent={<NewClientButton size="md" />}
      />
    );
  }

  const lowerCaseSearchTerm = searchTerm.toLowerCase();

  const filteredClients = agencyClients.filter(
    ({ first_name: firstName, last_name: lastName, email }) => {
      const isMatchingFirstName = firstName
        ?.toLowerCase()
        .includes(lowerCaseSearchTerm);

      const isMatchingLastName = lastName
        ?.toLowerCase()
        .includes(lowerCaseSearchTerm);

      const isMatchingEmail = email
        ?.toLowerCase()
        .includes(lowerCaseSearchTerm);

      return searchTerm
        ? isMatchingFirstName || isMatchingLastName || isMatchingEmail
        : true;
    },
  );

  const Component = isDesktop ? DesktopTable : MobileList;

  return (
    <>
      <SearchInput
        placeholder="Search clients"
        value={searchTerm}
        className="lg:max-w-80"
        variant={isDesktop ? "sm" : "lg"}
        onChange={(e) => setSearchTerm(e.target.value)}
        onClear={() => setSearchTerm("")}
      />

      {filteredClients.length ? (
        <Component clients={filteredClients} />
      ) : (
        <EmptyPlaceholder
          title="No clients found"
          subtitle="No clients match your search criteria. Try adjusting your search"
          imageSrc={ResultNotFoundImage}
          actionComponent={
            <Button onClick={() => setSearchTerm("")}>Clear search</Button>
          }
        />
      )}
    </>
  );
}
